export var getVisitorStatus = function (t, status) {
    if (status === 'ADMIN') {
        return t('COLLECTIONS_MEMBER_ROLE_OWNER');
    }
    else if (status === 'MEMBER') {
        return t('COLLECTIONS_MEMBER_ROLE_MEMBER');
    }
    else {
        return t('COLLECTIONS_MEMBER_ROLE_GUEST');
    }
};
export var getGalleryById = function (galleries, galleryId) {
    var index = -1;
    var currentGallery = galleries.find(function (gallery, ind) {
        if (gallery.id === galleryId) {
            index = ind;
            return gallery;
        }
    });
    return { currentGallery: currentGallery, index: index };
};
export var getGalleryDownloadLink = function (motherSiteMetaSiteId, id, galleryId) {
    return "https://www.wix.com/_api/albums-node-server/downloadZip?metaSiteId=".concat(motherSiteMetaSiteId, "&instanceId=").concat(id, "&state=PUBLISHED&setId=").concat(galleryId);
};
//# sourceMappingURL=elementsUtils.js.map